import React from 'react'
import { Link } from 'react-router-dom'
import user from '../images/user.png'

const ContactCard = (props) => {
    const { id, name, email } = props.contact;
    return (
        <div className="item">
            <div className="content">
                <img className="ui avtar image" src={user} alt="user" style={{ height: "30px", width: "30px", float: "left", margin: "5px" }} />

                <Link to={{ pathname: `/contact/${id}`, state: { contact: props.contact } }}>
                    <div className="header" > {name}</div>
                    <div>{email}</div>
                </Link>

                <i className="trash alternate outline icon" style={{ color: "red", float: 'right', marginBottom: "15px" }}
                    onClick={() => props.clickHandler(id)}></i>
            </div>
        </div>
    )
}

export default ContactCard



// WEBPACK FOOTER //
// ./src/components/ContactCard.js